import type { PlanAction, PlanCheckResult } from '@graphit/types'
import axios from 'axios'

import env from '../environments'

export async function isActionAllowedByPlan(action: PlanAction, cartographyId?: string) {
	const params: Record<string, string> = { action }
	if (cartographyId) params.cartographyId = cartographyId

	const response = await axios.get<PlanCheckResult>(`${env.apiUrl}/plan-limits/is-allowed-by-plan`, { params })

	return response.data
}
